angular.module('ngApp')
.controller('numTreesController', ['$scope', '$rootScope', function ($scope, $rootScope) {}])
.controller('numUsersController', ['$scope', '$rootScope', function ($scope, $rootScope) {}])
.controller('numOrganizationsController', ['$scope', '$rootScope', function ($scope, $rootScope) {}])
.controller('numCountriesController', ['$scope', '$rootScope', function ($scope, $rootScope) {}])
.controller('numProjectsController', ['$scope', '$rootScope', function ($scope, $rootScope) {}])
.controller('numEmissionController', ['$scope', '$rootScope', function ($scope, $rootScope) {}])
